import { Icon } from "@/components/ui/icon";

/** Orange branded sidebar shared by the export wizards. */
export function ExportWizardSidebar({
  title,
  description,
  features,
}: {
  title: React.ReactNode;
  description: string;
  features: string[];
}) {
  return (
    <div className="hidden w-[280px] shrink-0 flex-col justify-between border-r border-border bg-[#FFAF53] px-7 py-8 sm:flex">
      <div className="flex flex-col gap-4">
        <div className="flex items-center gap-2">
          <Icon name="IconArrowInbox" size={22} className="text-black" />
          <span className="text-base font-semibold text-black">Export</span>
        </div>
        <div className="mt-4 flex flex-col gap-2">
          <h2 className="text-2xl font-semibold leading-tight text-black">
            {title}
          </h2>
          <p className="text-[13px] leading-relaxed text-black/60">
            {description}
          </p>
        </div>
      </div>
      <div className="mt-8 flex flex-col gap-3">
        {features.map((f) => (
          <div key={f} className="flex items-center gap-2.5">
            <div className="flex size-5 shrink-0 items-center justify-center rounded-full bg-black/10">
              <Icon name="IconCheckmark1" size={12} className="text-black" />
            </div>
            <span className="text-[13px] text-black/80">{f}</span>
          </div>
        ))}
      </div>
    </div>
  );
}

export function ExportWizardCloseButton({ onClose }: { onClose: () => void }) {
  return (
    <button
      type="button"
      aria-label="Close"
      onClick={onClose}
      className="absolute right-3.5 top-3.5 z-10 flex size-6 items-center justify-center rounded-md transition-colors cursor-pointer hover:bg-contrast/6"
    >
      <Icon
        name="IconCrossMedium"
        size={14}
        className="text-contrast/40 hover:text-contrast/70"
      />
    </button>
  );
}
